import {
  AkinatorCompletion,
  CategorySuggestion,
  NewSuggestion,
  SlicedSuggestions,
  Suggestion,
  Suggestions,
} from 'types/suggestions';
import { getSRPSuggestionUrl } from 'utils/get-srp-suggestion-url';
import { getURLWithLoggingContext } from 'utils/get-url-with-logging-context';

type PreparedSuggestions = {
  slicedSuggestions: SlicedSuggestions | null;
  flatSuggestions: Suggestion[] | null;
  akinatorCompletions: AkinatorCompletion[] | null;
};

export const prepareSuggestions = (
  suggestions: Suggestions | null,
  value: string,
  searchHref: string,
  responseId: string,
): PreparedSuggestions => {
  if (!suggestions) {
    return {
      slicedSuggestions: null,
      flatSuggestions: null,
      akinatorCompletions: null,
    };
  }

  const isDefaultList = !value;
  const slicedSuggestions = isDefaultList
    ? getDefaultListSuggestions(suggestions.newSuggestions, suggestions.categories)
    : getSearchSuggestions(suggestions.newSuggestions, value, searchHref, responseId);

  return {
    slicedSuggestions,
    flatSuggestions: [...slicedSuggestions[0], ...slicedSuggestions[1]],
    akinatorCompletions: isDefaultList ? [] : suggestions.completions,
  };
};

function getDefaultListSuggestions(
  newSuggestions: NewSuggestion[],
  categories: CategorySuggestion[],
): SlicedSuggestions {
  if (categories.length > 0) {
    return [[], categories];
  }

  return [newSuggestions, []];
}

function getSearchSuggestions(
  newSuggestions: NewSuggestion[],
  value: string,
  searchHref: string,
  responseId: string,
): SlicedSuggestions {
  if (newSuggestions.length > 0) {
    return [newSuggestions, []];
  }

  const baseUrl = getSRPSuggestionUrl(searchHref, value);
  const pageUrl = getURLWithLoggingContext(baseUrl, responseId, value, 'SRP', 'suggestion');

  const emptySuggestion: NewSuggestion = {
    name: value,
    pageId: null,
    pageUrl,
    type: 'SRP',
    familyId: null,
    imageUrl: null,
    labels: [],
    fillingOrder: 0,
  };

  return [[emptySuggestion], []];
}
